import * as React from "react";
import { SVGProps } from "react";
export function ExpandWindowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={11}
      height={11}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#expand-window_svg__a)"
        stroke="#21597A"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.605 6.286V9.82a.786.786 0 0 1-.786.786H1.176a.786.786 0 0 1-.785-.786V1.18a.786.786 0 0 1 .785-.786h3.536M7.852.393h2.75v2.75M10.607.393 5.5 5.5" />
      </g>
      <defs>
        <clipPath id="expand-window_svg__a">
          <path fill="#fff" d="M0 0h11v11H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
